/** Shared option lists and formatters for the Payroll & Expenses tabs. */

export const EXPENSE_CATEGORY_OPTIONS = [
  { label: "Expense", value: "expense" },
  { label: "EMI / Recurring Expense", value: "emiRecurring" },
];

export const EMI_STATUS_OPTIONS = [
  { label: "Upcoming", value: "upcoming" },
  { label: "Current", value: "current" },
  { label: "Paused", value: "paused" },
  { label: "Completed", value: "completed" },
  { label: "Foreclosed", value: "foreclosed" },
];

export const INSTALLMENT_STATUS_OPTIONS = [
  { label: "Pending", value: "pending" },
  { label: "Processed", value: "processed" },
];

export const SALARY_STATUS_OPTIONS = [
  { label: "Pending", value: "pending" },
  { label: "Approved", value: "approved" },
  { label: "Transferred", value: "transferred" },
  { label: "On Hold", value: "onHold" },
  { label: "Rejected", value: "rejected" },
];

/** OMR is a 3-decimal currency. */
export function formatOmr(value) {
  if (value === null || value === undefined || value === "") return "—";
  return Number(value).toLocaleString("en-US", {
    minimumFractionDigits: 3,
    maximumFractionDigits: 3,
  });
}
